import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
// Redirect bare '/' to '/id' before React renders
if (window.location.pathname === '/') {
  window.history.replaceState({}, '', '/id');
}
// Set initial lang attribute synchronously before React renders
const initialLang = window.location.pathname.startsWith('/en') ? 'en' : 'id';
document.documentElement.lang = initialLang;
document.documentElement.setAttribute('dir', 'ltr');
render(<ErrorBoundary data-id="element-357">
    <App data-id="element-358" />
  </ErrorBoundary>, document.getElementById('root'));